/**
 * Groepeert antwoordopties per veld, op volgorde.
 *
 * Het sorteren gebeurt hier en niet in de Firestore-query: een `orderBy` op
 * `Position` naast het filter op de omgeving vraagt een samengestelde index die
 * er niet is — en zo'n mislukte query is stil, dus het scherm toont dan gewoon
 * 'geen opties'. Bovendien laat een `orderBy` juist de opties wegvallen die
 * `Position` missen.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-missing-composite-index
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-orderby-excludes-missing-field
 *
 * @param {Array<object>} [options] - Documenten uit MultipleQuestionOptions
 * @returns {Record<string, Array<object>>} per Field-waarde de opties, op volgorde
 */
const groupOptionsByField = (options) => {
    /** @type {Record<string, Array<object>>} */
    const perVeld = {}

    for (const optie of Array.isArray(options) ? options : []) {
        const sleutel = optie?.Field
        if (!sleutel) continue
        if (!perVeld[sleutel]) perVeld[sleutel] = []
        perVeld[sleutel].push(optie)
    }

    for (const sleutel of Object.keys(perVeld)) {
        perVeld[sleutel].sort((a, b) => (Number(a?.Position) || 0) - (Number(b?.Position) || 0))
    }

    return perVeld
}

export default groupOptionsByField
